import type { FC } from 'react';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import type { TextProps } from '@polyai/ui/components/atoms/Text';
import Text from '@polyai/ui/components/atoms/Text';
import type { TooltipProps } from '@polyai/ui/components/atoms/Tooltip';
import Tooltip from '@polyai/ui/components/atoms/Tooltip';

dayjs.extend(relativeTime);

export interface Props {
  timestamp: string;
  format?: string;
  tooltipProps?: Partial<TooltipProps>;
  textProps?: Partial<TextProps>;
}

const TimeAgoTooltip: FC<Props> = ({
  timestamp,
  format = 'DD MMM YYYY HH:mm:ss',
  tooltipProps,
  textProps,
}) => {
  return (
    <Tooltip
      content={dayjs(timestamp).format(format)}
      placement="bottom"
      {...tooltipProps}
    >
      <Text
        color="textSecondary"
        decoration="underline dashed"
        decorationColor="borderUnderline"
        variant="bodySmall"
        {...textProps}
      >
        {dayjs(timestamp).fromNow()}
      </Text>
    </Tooltip>
  );
};

export default TimeAgoTooltip;
